<!-- Titolo, contenuto e barra azioni sono figli DIRETTI della superficie del
     dialog, che Material dispone come flex column: e' cosi' che la fascia
     panna delle azioni resta a filo del bordo inferiore anche quando la
     superficie e' piu' alta del contenuto. Chiusi in un <div> di
     raggruppamento - com'era prima questo template, un'unica colonna centrata -
     diventano figli di un blocco, e le regole di .izy-info-dialog-panel non
     avrebbero piu' niente da vestire. -->
<h2 mat-dialog-title class="izy-contact-title">
  Contattaci
  <mat-icon>person_pin</mat-icon>
</h2>

<mat-dialog-content>
  <p>{{ text }}</p>

  <!-- .izy-fields e' il contenitore che veste i campi con la grammatica BEIZY
       (contorno nero 2px, raggio 16px): lo stesso di tutti gli altri form
       dell'app. Definito in styles.scss. -->
  <div class="izy-fields">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>La nostra mail</mat-label>
      <input
        matInput
        [value]="invoicingEmail"
        readonly
        #linkInput>
      <button
        mat-icon-button
        matSuffix
        (click)="copyToClipboard()"
        [attr.aria-label]="'Copia link'">
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <!-- Azione secondaria dentro il contenuto: pillola bianca bordata nera 2px.
       Il petrol pieno resta al solo "Copia mail" nella fascia delle azioni -
       due pulsanti petrol sulla stessa schermata non direbbero piu' quale dei
       due e' il gesto della schermata. -->
  <button
    *ngIf="invoicingEmail === 'info@izysrl.it' && data.organization && data.organization.is_only_invoicing==false"
    mat-stroked-button
    class="w-100 izy-button-ghost custom-button-border"
    (click)="copyAndRedirect()">
    <mat-icon>category_search</mat-icon>
    Esplora i nostri servizi aggiuntivi
  </button>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- Sulla fascia panna: pillola bianca per l'uscita neutra, petrol pieno per
       l'azione che si vuole compiere. -->
  <button
    mat-stroked-button
    mat-dialog-close
    class="izy-button-ghost custom-button-border"
    (click)="onCancel()">
    Esci
  </button>
  <button
    mat-raised-button
    matButton="filled"
    class="ms-2 izy-button-primary custom-button-border"
    (click)="copyToClipboard()">
    <mat-icon>content_copy</mat-icon>
    Copia mail
  </button>
</mat-dialog-actions>
